
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"icon",attrs:{"stroke":"#e60000","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"50","fill":"none"}},[_c('path',{attrs:{"d":"M19 1l5 5-5 5m4-5H1"}}),_c('path',{attrs:{"d":"M19 1l5 5-5 5m4-5H1"}})])])
          )
        }
      }
    